// Public surface of the auth feature. Every later frontend task that needs to know who is signed
// in, sign someone in, sign someone out, or react to a CSRF refusal imports from here rather than
// reaching into `features/auth/**` directly.
export { activateAccount, getProfile, listSessions, login, logout, registerAccount, revokeSession } from './api';
export type { ActivationRequest, AuthenticatedUser, LoginRequest, Profile, RegisterRequest, Session } from './api';
export { CsrfRecoveryNotice, isCsrfTokenInvalid } from './components/CsrfRecovery';
export { SignInForm } from './components/SignInForm';
export { INVESTOR_DOOR, PROTECTED_PREFIX_DOORS, signInPathFor, STAFF_DOOR, STAFF_DOOR_PREFIXES } from './doors';
export {
  getApiError,
  getApiErrorCode,
  getApiErrorMessage,
  isAuthenticationRequired,
  isTotpRequired,
} from './errors';
export type { ApiError } from './errors';
export { SESSION_QUERY_KEY, SessionError, useInvalidateSession, useSession } from './hooks/useSession';
export { SESSIONS_QUERY_KEY, useRevokeSession, useSessions } from './hooks/useSessions';
